import { isEmpty } from 'lodash'

import validates from 'helpers/validates'

import constants from 'constants/index'

const { STRING_SCHEMA_TYPE } = constants.validations

const cpfOrCnpj = {
  name: 'cpfOrCnpj',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'CPF ou CNPJ inválido') {
    return this.test(
      'cpfOrCnpj',
      message,
      (value) => isEmpty(value) || validates.cpfOrCnpj.isValid(value),
    )
  },
}

export default cpfOrCnpj
